import React from 'react';
import { ChatMessage, MessageUserType } from '@missionlabs/smartagent-chat-components-lib';
import ArrowDownRight from 'images/arrow-down-right.svg';
import './source-message.scss';

interface Props {
    messageContent: string;
    messageLink?: string;
    timestamp: number;
}

const SourceMessage: React.FC<Props> = ({ messageContent, messageLink, timestamp }) => (
    <>
        <div className="source-message-title row middle between">
            <h2>Original post:</h2>
            {messageLink && (
                <a href={messageLink} target="_blank" rel="noreferrer">
                    Link to original post
                </a>
            )}
        </div>
        <ChatMessage
            sendMessage={(msg: string) => {}}
            clientType={MessageUserType.AGENT}
            senderType={MessageUserType.CUSTOMER}
            time={new Date(timestamp).toISOString()}
            body={{
                type: 'TEXT',
                text: messageContent,
            }}
        />
        <div className="source-message-customer row start">
            <img src={ArrowDownRight} alt="arrows" />
            <p>Customer comment:</p>
        </div>
    </>
);

export default SourceMessage;
